module.exports = __webpack_public_path__ + "static/media/way_three.7eddd1e7.png";